import { render } from "./edittransfer.vue?vue&type=template&id=5a44b26e"
import script from "./edittransfer.vue?vue&type=script&lang=js"
export * from "./edittransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__